import { hasFeature } from '@/services/featureService';
import { isSupervisor } from '@/services/userService';
import type { ExtendedUserResponseSchema } from '@/types/user.types';

/** Delivery Team (OPERATOR), Supervisor, and Admin may edit when the feature flag is on. */
export const canManageDeliveryInvoice = (
  user: ExtendedUserResponseSchema | null | undefined
): boolean => {  if (!hasFeature('delivery.invoice.edit')) {
    return false;
  }

  if (!user) {
    return false;
  }

  return user.roleId === 'ADMIN' || user.roleId === 'OPERATOR' || isSupervisor(user);
};
